import mutate from '@wittignl/js-core/apollo/mutations/mutate'

import ForgotPassword from 'gql/mutations/userPasswordRequest/ForgotPassword.gql'
import RenewPassword from 'gql/mutations/userPasswordRequest/RenewPassword.gql'
import ResetPassword from 'gql/mutations/userPasswordRequest/ResetPassword.gql'

export default class {

    static forgotPassword(email){

        return mutate(ForgotPassword, { email });
    }

    static renewPassword(data){

        return mutate(RenewPassword, data);
    }

    static resetPassword(data){

        return mutate(ResetPassword, data);
    }
}
